// Dropdown-triggered (scope) re-fetches from SampleComments share the
// FETCH_COMMENTS_AND_GIST_* actions and fetchCommentsAndGistApi slice with
// the page-level filter fetch, but must not flip `isProcessing` on that
// slice — AsyncSection unmounts the whole section, dropdowns included,
// whenever it's true. `requestId` still guards every call: a response that
// resolves after a newer request has already been issued (e.g. the user
// changed the dropdown again before the first call returned) is dropped.
export const handleCommentsAndGistStart = (state, payload) => ({
    ...state,
    fetchCommentsAndGistApi: {
        ...state.fetchCommentsAndGistApi,
        isProcessing: payload.isScopeFetch ? state.fetchCommentsAndGistApi.isProcessing : true,
        error: false,
        reason: '',
        latestRequestId: payload.requestId,
    },
});

export const handleCommentsAndGistSuccess = (state, payload) => {
    if (payload.requestId !== state.fetchCommentsAndGistApi.latestRequestId) {
        return state;
    }
    return {
        ...state,
        fetchCommentsAndGistApi: {
            ...state.fetchCommentsAndGistApi,
            isProcessing: false,
            error: false,
            reason: '',
            data: payload.data.data,
        },
        isVisualizationDataFectched: true,
    };
};

export const handleCommentsAndGistFail = (state, payload) => {
    if (payload.requestId !== state.fetchCommentsAndGistApi.latestRequestId) {
        return state;
    }
    return {
        ...state,
        fetchCommentsAndGistApi: {
            ...state.fetchCommentsAndGistApi,
            isProcessing: false,
            // A failed scope re-fetch shouldn't hide the whole section (and
            // its dropdowns) behind AsyncSection's HIDDEN state.
            error: payload.isScopeFetch ? state.fetchCommentsAndGistApi.error : true,
            reason: '',
        },
    };
};
